
import {initWebComponent} from "@/helpers/web-component-helper";

export class LayerInfoFilterSettingsButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<a href="#" class="text-secondary font-weight-bold" data-test="layer_info_filter_settings_button">Instellingen</a>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            this.firstChild.classList.add('font-weight-bold')
            document.querySelector('layer-info-filter-result-button').firstChild.classList.remove('font-weight-bold')
            document.querySelector('layer-info-filter-result').classList.add('d-none')
            document.querySelector('layer-info-filter-settings').classList.remove('d-none')
            document.querySelector('layer-info-filter-switcher').classList.remove('d-none')

        })
    }
}

